import React from 'react';

const StepIndicator = ({ currentStep, steps }) => {
  return (
    <div className="step-wizard-nav">
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isActive = stepNumber === currentStep;
        const isCompleted = stepNumber < currentStep;
        
        return (
          <div key={stepNumber} className="step-wizard-item">
            <div className={`step-wizard-circle ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}>
              {isCompleted ? (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                </svg>
              ) : (
                stepNumber
              )}
            </div>
            <span className={`step-wizard-label ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}>
              {step.title}
            </span>
            {index < steps.length - 1 && (
              <div className={`step-wizard-line ${isCompleted ? 'completed' : ''}`}></div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default StepIndicator; 